import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, TabPane, Table} from "semantic-ui-react"
import {Row, Col, Form, FormField, FormInput} from "elemental-react16"
import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import Responsive                                                from "react-responsive"
import NewCustomerPage from "./NewCustomerPage"
import ResetPasswordPage from "./ResetPasswordPage"
import NewCustomerContactPage from "./NewCustomerContactPage"

@withRouter
export default class LoginPage extends Component {
	constructor() {
		super()
		this.state = {
			user    : "10000",
			password: "12345",
			login: true,
			register: false,
			resetPW: false,
			customerRegister: false,
		}
		shop.whoami()
	}
	
	componentDidMount() {
		const {history} = this.props
		console.log("LoginPage mounted", this.props)
		if (this.props.location.search && this.props.location.search.endsWith("login")) {
			this.setState({
				login: true,
			})
		}
		if (this.props.location.search && this.props.location.search.endsWith("register")) {
			this.setState({
				register: true,
				login: false,
			})
		}
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.loginOrfix( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then ( async session => {
				if ( !session ) return
				await this.handleSetOrderList()
				shop.loadCategories()
				await shop.cart.hydrateLogin()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				const handId    = session.handId;
				if (handId && handId != '') {
					redirectTo = "/login/accounts/"
				  }

				console.log( "AFTER", redirectTo )
				console.log( "AFTER", shop.locationAfterLogin, referrer, query , history)
				if(shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus"){
					console.log("Checking for custom redirect after login", shop.config.plugin)
					history.push( "/quickorder" )
				}
				else{
					if ( redirectTo && redirectTo !== "/login/" && redirectTo !== "/login" && redirectTo !== "/login?referrer=login" && redirectTo !== "/login?referrer=login/"
						&& redirectTo !== "/register" && redirectTo !== "/register" && redirectTo !== "/register?referrer=register" && redirectTo !== "/register?referrer=register/"
						&& redirectTo !== "/home/login/" && redirectTo !== "/home/login"
					) {
						history.push( redirectTo )
					} else {
						history.push( "/home" )
					}
				}
			} )

		e.preventDefault()
	}

	handleSetOrderList = async () => {
		let { currentList } = shop.store.orderlist
		console.log("currentList", currentList, JSON.stringify(shop.orderlist.lists), shop.orderlist.lists.Standard)
		if(shop.orderlist && shop.orderlist.lists && shop.orderlist.lists.Standard && shop.orderlist.lists.Standard.title == "Standard" && currentList == false){
			console.log("Setting current list to Standard", shop.orderlist.lists.Standard)
			shop.store.orderlist.setCurrentList( shop.orderlist.lists.Standard )
		}
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}



	handleTabButtons = (name ) => {
		if (name === "login") {
			this.setState({
				login: true,
				register: false
			})
		} else if (name === "register") {
			this.setState({
				login: false,
				register: true
			})
		}
		window.scrollTo({ top: 0, behavior: "smooth" });
	}


	render() {
		const { login, register, resetPW, customerRegister } = this.state
		console.log("this.props", this.props)
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log("Checking for custom redirect after login", shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme)
		return (<Fragment>
				{shop.config && shop.config.plugin && shop.config.plugin.loginPageV1 && <div className={`container loginPageBackgroundDesktopV1 ${ (this.state.login) ? 'is-expandedBackgroundV1' : '' }`}>
					<div className={`loginPageContentV1 ${ (this.state.register) ? 'is-expandedV1' : '' }`}>
						<div className="loginPageFooterV1">© 2025 Trendsoft GmbH</div>
						<div className="pb5" >
							<Link className={"logo"} to="/home/">
								<img 
								src={shop.config.logo}
								alt="" />
							</Link>
							</div>
						<div className="flex flex-row justify-center " >
							
							<div  style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
							<div className=" pb2" style={{borderBottom: `${login ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button  className="buttonLoginPage" style={{ minWidth: "100px",  borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${login ? "none" : "none"}`, 
								backgroundColor: `transparent`, }} onClick={() => this.handleTabButtons("login")}><p className="pa2 fw6 f4">{translate("Anmelden")}</p></button></div>
								<div className=" pb2" style={{borderBottom: `${register ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonLoginPage" style={{ minWidth: "100px",  borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${register ? "none" : "none"}`, 
								backgroundColor: `transparent`, }} onClick={() => this.handleTabButtons("register")}><p className="pa2 fw6 f4">{translate("Registrieren")}</p></button></div>
								<div className="" style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
						</div>
						{register && <Fragment>
							<NewCustomerPage />
							<div className="tc ">
							<div className="flex flex-row justify-center pt3"  >
						<div className="pr1 fw7 f6">{translate( "Sie haben bereits ein Konto?" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.handleTabButtons("login")}>{translate( "Hier anmelden" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
						
					</div></Fragment>}
					{login && <Fragment>

						<div className="flex flex-row justify-center pa3" >
							<p className="fw7 pa3"><h1 className="fw7">{translate("Anmeldung")}</h1></p>
						</div>
						<div className="flex flex-row justify-center pb2" >
							<p className="fw6 f5 black-50">{translate("loginHint")} </p>
						</div>

							<div className="">
								<Form onSubmit={this.handleLogin}>
									<FormField label={translate("Benutzer")} style={{}}
											   title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
											   htmlFor="basic-form-input-email">
										<FormInput style={{width: "100%", borderRadius: "35px", backgroundColor: "#ffffff"}} value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={ translate("E-Mail-Adresse / Kunden-Nr.")}
												   name="basic-form-input-id" />
									</FormField>
									<FormField label={translate("Passwort")}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									<div className="tc pt3 pb3">
										<Button style={{ width: "100%", borderRadius: "35px", height: "50px"}}
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<Link className="db mt3 fw7 f6" style={{color: "#a2cf66"}}
											  onClick={() => {this.setState({resetPW: !resetPW})}}>{translate( "Passwort vergessen" )}?</Link>
											  {resetPW && <div className="pb3 pt3"><ResetPasswordPage /></div>}
									</div>
								</Form>
							</div>
						<div className="tc ">
							<div className="flex flex-row justify-center pt3" style={{ borderTop: "2px solid rgb(201, 201, 201)"}} >
						<div className="pr1 fw7 f6">{translate( "loginpage.noaccounthint" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6"  onClick={() => this.handleTabButtons("register")}>{translate( "loginpage.registerlink" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
					</div>
					</Fragment>}
					<div className="flex flex-row justify-center pt2"  >
						<div className="pr1 fw7 f6">{translate( "loginpage.alreadycustomer" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.setState({customerRegister: true})}>{translate( "loginpage.requestlogin" )}</Link> <br />
						<Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
							<Modal.Header>
							<div className="flex flex-row justify-between items-center">
								<div>{translate( "Zugang anfordern" )}</div>
								<Button basic circular
										onClick={() => {
										this.setState({ customerRegister: false})
										}}
										icon="times"
								/>
							</div>
							
							</Modal.Header>
							<Modal.Content>
										<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
							</Modal.Content>
						</Modal>
						</div>
					</div>
				</div>}
				{shop.config && shop.config.plugin && shop.config.plugin.loginPageV2 && <div className={`container loginPageBackgroundDesktopV2 ${ (this.state.register) ? 'is-expandedBackgroundV2' : '' }`}>

					<div className={`loginPageContentV2 ${ (this.state.register) ? 'is-expandedV2' : '' }`}>
						<div className="loginPageFooterV2">© 2025 Trendsoft GmbH</div>
						<div className="pb5" >
							<Link className={"logo"} to="/home/">
								<img className="logoLogin"
								src={shop.config.logo}
								alt="" />
							</Link>
							</div>
						<div className="flex flex-row justify-center" >
							
							<div  style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
							<div className=" pb2" style={{borderBottom: `${login ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button  className="buttonLoginPage" style={{ minWidth: "100px",  borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${login ? "none" : "none"}`, 
								backgroundColor: `transparent`, }} onClick={() => this.handleTabButtons("login")}><p className="pa2 fw6 f4">{translate("Anmelden")}</p></button></div>
								<div className=" pb2" style={{borderBottom: `${register ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonLoginPage" style={{ minWidth: "100px",  borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${register ? "none" : "none"}`, 
								backgroundColor: `transparent`, }} onClick={() => this.handleTabButtons("register")}><p className="pa2 fw6 f4">{translate("Registrieren")}</p></button></div>
								<div className="" style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
						</div>
						{register && <Fragment>
							<NewCustomerPage />
							<div className="tc ">
							<div className="flex flex-row justify-center pt3"  >
						<div className="pr1 fw7 f6">{translate( "Sie haben bereits ein Konto?" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.handleTabButtons("login")}>{translate( "Hier anmelden" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
						
					</div></Fragment>}
					{login && <Fragment>
						
						<div className="flex flex-row justify-center pa3 "  >
							<p className="fw7 pa3 pb2 pt2"><h1 className="fw7">{translate("Anmeldung")}</h1></p>
						</div>
						<div className="flex flex-row justify-center pb2" >
							<p className="fw6 f6 black-50">{translate("loginHint")} </p>
						</div>

							<div className="">
								<Form onSubmit={this.handleLogin}>
									<FormField label={translate("Benutzer")} style={{}}
											   title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
											   htmlFor="basic-form-input-email">
										<FormInput style={{width: "100%", borderRadius: "35px", backgroundColor: "#ffffff"}} value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={ translate("E-Mail-Adresse / Kunden-Nr.")}
												   name="basic-form-input-id" />
									</FormField>
									<FormField label={translate("Passwort")}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tc pt3 pb3">
										<Button style={{ width: "100%", borderRadius: "35px", height: "50px"}}
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<Link className="db mt3 fw7 f6" style={{color: "#a2cf66"}}
											  onClick={() => {this.setState({resetPW: !resetPW})}}>{translate( "Passwort vergessen" )}?</Link>
											  {resetPW && <div className="pb3 pt3"><ResetPasswordPage /></div>}
									</div>
								</Form>
							</div>
						<div className="tc ">
							<div className="flex flex-row justify-center pt3" style={{ borderTop: "2px solid rgb(201, 201, 201)"}} >
						<div className="pr1 fw7 f6">{translate( "loginpage.noaccounthint" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6"  onClick={() => this.handleTabButtons("register")}>{translate( "loginpage.registerlink" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
					</div>
					</Fragment>}
					<div className="flex flex-row justify-center pt2"  >
						<div className="pr1 fw7 f6">{translate( "loginpage.alreadycustomer" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.setState({customerRegister: true})}>{translate( "loginpage.requestlogin" )}</Link> <br />
						<Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
							<Modal.Header>
							<div className="flex flex-row justify-between items-center">
								<div>{translate( "Zugang anfordern" )}</div>
								<Button basic circular
										onClick={() => {
										this.setState({ customerRegister: false})
										}}
										icon="times"
								/>
							</div>
							
							</Modal.Header>
							<Modal.Content>
										<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
							</Modal.Content>
						</Modal>
						</div>
					</div>
				</div>}

		</Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/LoginPage.js